module.exports = __webpack_public_path__ + "static/media/CY_logo.f4846c04.svg";